import { render, staticRenderFns } from "./MainTextarea.vue?vue&type=template&id=1fbd58ba&scoped=true"
import script from "./MainTextarea.vue?vue&type=script&lang=js"
export * from "./MainTextarea.vue?vue&type=script&lang=js"
import style0 from "./MainTextarea.vue?vue&type=style&index=0&id=1fbd58ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbd58ba",
  null
  
)

export default component.exports